<script>
import { mapActions, mapState } from 'pinia';
import { orderStore } from '../../../stores/order';
import { basketStore } from '../../../stores/basket';
import { Tools } from '../../../utils/tools';
import { TabItem, TabList, TabContent, TabContentList } from '@/components/order-vue/order/components/tabs/index.js';
import FadeInOutTransition from '@/components/order-vue/order/components/transitions/FadeInOutTransition.vue';
import FormUserAgreement from '@/components/order-vue/order/components/form/form-user-agreement.vue';

export default {
	components: {
		FormUserAgreement,
		FadeInOutTransition,
		TabContent,
		TabContentList,
		TabList, 
		TabItem
	},
	
	inject: [
		'basketMode',
		'orderMode',
		'combinedMode',
		'defaultUserAgreementStatus',
		'basketPageLocation',
		'orderPageLocation'
	],

	props: {
		isValid: {
			type: Boolean,
			default: false
		}
	},
	
	computed: {
		...mapState(orderStore, {
			isLoaded : 'isLoaded',
			isOrderReadyToOrder: 'isReadyToOrder' ,
			propertyByCode: 'getPropertyByCode',
			getValue: 'fieldValue',
			setValue: 'setFieldValue'
		}),
		
		...mapState(basketStore, {
			isBasketOrderable: 'isOrderable'
		}),
		
		processTabs() {
			return this.propertyByCode('PROCESS');
		},

		processValue() {
			if (!this.processTabs) return null;
			return this.getValue(this.processTabs.id) ?? this.processTabs.defaultValue;
		},
		
		currentProcessOption() {
			return this.processValue ? (this.processTabs.optionsDescriptions[this.processValue] ?? this.processTabs.options[this.processValue]) : null;
		}
	},

	methods: {
		...mapActions(orderStore, ['registerOrder']),
		
		formatPrice(price) {
			return Tools.formatPrice(price);
		},

		handleTabSelect(value) {
			this.setValue(this.processTabs.id, value);
			this.activeTab = value;
		}
	}
};
</script>

<template>
	<div v-if="isLoaded" class="checkout-options checkout-item">
		<h3 class="checkout-item__title">{{ $loc.get('FINAL_TITLE') }}</h3>
		<div class="checkout-item__wrapper">
			
			<TabList v-model:model-value="processValue" container-class="checkout-item__tabs">
				<TabItem
					v-for="(name, id) in processTabs.options"
					:key="id"
					:value="id"
					:active="processValue === id"
					@select="handleTabSelect(id)"
				>
					{{ name }}
				</TabItem>
			</TabList>
			<TabContentList :class-list="[ 'checkout-item__tabs-body' ]" >
				<input type="hidden" :name="processTabs.fieldName" :value="processValue" />
				<FadeInOutTransition>
					<TabContent
						v-if="processValue"
						:key="processValue"
						:value="processValue"
						:active-tab="processValue"
					>
						<button 
							class="checkout-items__submit button button--primary" 
							type="submit" 
							:disabled="!isValid"
							@click.prevent="registerOrder"
						>{{ currentProcessOption }}</button>
					</TabContent>
				</FadeInOutTransition>
			</TabContentList>
			
			<FormUserAgreement/>
		</div>
	</div>
</template>
